module.exports = fox => {
	fox.registerWidget('FakeChatList', {
		configure() {
			this.registerOptions('', {
				'embed.container': '#sidebar-main-container',
				autoRender: true,
				template: 'ls_viewer_sidebar_main_chat_list_container',
				scrollContainer: '.chat-list-scroll-wrapper',
				scrollTheme: 'minimal',
				'widgets.chatList': {
					'tpl.row': 'ls_viewer_sidebar_main_chat_list_row',
					'embed.container': '#chat-list-container'
				}
			});

			this.callParent('configure', arguments);
		},

		genRandomString(length) {
			const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 ";
			let text = '';

			for (var i = 0; i < length; i++) {
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			}

			return text;
		},

		getMemberInfo(...args) {
			return this.requireOption('getMemberInfo')(...args);
		},

		deactivate() {
			this.reset();
			this.dispose();
			this.callParent('deactivate', arguments);
		},

		dispose() {
			clearTimeout(this._timer);
			this._timer = null;
		},

		afterEmbed() {
			const addMessage = (delay = false) => {
				const modelName = fox.getEnv('screenName');

				const messages = fox.range(0, fox.random(1, 5)).map(id => {
					const isBroadcaster = fox.random(1, 4) === 4;
					const message = {
						text: this.genRandomString(fox.random(10, 80)),
						name: isBroadcaster ? modelName : this.getMemberInfo('login'),
						isBroadcaster
					};

					if (!isBroadcaster && fox.random(1, 5) === 5 /* just random */) {
						return {
							...message,
							text: 'gift',
							type: 1,
							gift: `gift-${fox.random(0, 11)}`,
							price: `${fox.random(5, 20)}$`
						}
					}

					return message;
				});

				if (!delay)
					return this.addMessage(messages);

				return setTimeout(() => {
					this.addMessage(messages);

					if (this.isActive())
						return this._timer = addMessage(fox.random(5000, 10000));
				}, delay);
			}

			this.callParent('afterEmbed', arguments);

			addMessage();
			this._timer = addMessage(3000);
		}
	}, 'LSChatList');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/FakeChat.es.js